module.exports = __webpack_public_path__ + "static/media/ds04.fc536e90.jpg";